import { useContext } from "react";
import { Datas } from "../../App";
import p from '../../styles/Profile.module.css';
import BackHome from "../../components/BackHome";

function Linux() {
    const data = useContext(Datas);

    const linuxSteps = [
        { text: 'Установите приложение Hiddify под вашу ОС из официальных релизов', href: 'https://github.com/hiddify/hiddify-app/releases' },
        { text: 'Откройте приложение Hiddify и вверху нажмите кнопку «+». Выберите «Добавить из буфера»', href: null },
        { text: 'Убедитесь, что подписка добавилась – внизу появится список стран, которые доступны для вашей подписки', href: null },
        { text: 'Нажмите вверху большую кнопку включения. VPN запущен!', href: null },
        { text: 'Вы можете изменить страну подключения, просто выбрав нужную локацию в списке', href: null },
    ];

    return (
        <>
            <BackHome />
            <div className={p.page}>
                <div className={p.section}>
                    <p className={p.section_title} style={{ cursor: 'default' }}>
                        Инструкция по настройке Linux:
                    </p>

                    <div className={p.steps}>
                        {linuxSteps.map((step, i) => (
                            <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                                <div className={p.step_row}>
                                    <div className={p.step_num}>{i + 1}</div>
                                    <div className={p.step_text}>
                                        {step.href ? (
                                            <a href={step.href} className={p.step_link} target="_blank" rel="noreferrer">
                                                {step.text}
                                            </a>
                                        ) : (
                                            <span>{step.text}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Linux;